import React from "react";
import "./../estilo.css";

export default class Cadastro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: "",
      passwd: "",
      email: "",
      phone: "",
      cpf: "",
      message: "",
      error: false,
      loading: false,
      termosAceitos: false,
      showTermos: false,
      regiao: "BR",

      produtos: [],
      pacotes: [],
      selectedProdutos: [],
      selectedPacoteId: "",
      tier: "starter",
      loadingCatalogo: false,
    };
  }

  componentDidMount() {
    this.fetchCatalogo();
  }

  fetchCatalogo = async () => {
    this.setState({ loadingCatalogo: true, message: "" });

    try {
      const [produtosRes, pacotesRes] = await Promise.all([
        fetch("https://quantumtrades.com.br:8080/api/produtos-ativos", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }),
        fetch("https://quantumtrades.com.br:8080/api/pacotes-ativos", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }),
      ]);

      const produtosData = await produtosRes.json();
      const pacotesData = await pacotesRes.json();

      if (!produtosRes.ok) {
        throw new Error(produtosData.message || "Erro ao carregar produtos.");
      }

      if (!pacotesRes.ok) {
        throw new Error(pacotesData.message || "Erro ao carregar pacotes.");
      }

      this.setState({
        produtos: Array.isArray(produtosData) ? produtosData : [],
        pacotes: Array.isArray(pacotesData) ? pacotesData : [],
        loadingCatalogo: false,
      });
    } catch (error) {
      this.setState({
        loadingCatalogo: false,
        error: true,
        message: "Erro ao carregar catálogo de licenciamento.",
      });
    }
  };

  handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox" && name === "termosAceitos") {
      this.setState({ termosAceitos: checked });
      return;
    }

    if (name === "regiao") {
      this.setState({ regiao: value });
      return;
    }

    if (name === "phone") {
      if (this.state.regiao === "BR") {
        const clean = value.replace(/\D/g, "").slice(0, 11);
        this.setState({ phone: this.formatPhone(clean) });
      } else {
        this.setState({ phone: value });
      }
      return;
    }

    if (name === "cpf") {
      if (this.state.regiao === "BR") {
        const clean = value.replace(/\D/g, "").slice(0, 11);
        this.setState({ cpf: this.formatCPF(clean) });
      } else {
        this.setState({ cpf: value });
      }
      return;
    }

    this.setState({ [name]: value });
  };

  toggleProduto = (produtoId) => {
    this.setState((prevState) => {
      const jaExiste = prevState.selectedProdutos.includes(produtoId);

      return {
        selectedPacoteId: "",
        selectedProdutos: jaExiste
          ? prevState.selectedProdutos.filter((id) => id !== produtoId)
          : [...prevState.selectedProdutos, produtoId],
      };
    });
  };

  selectPacote = (pacoteId) => {
    this.setState({
      selectedPacoteId: String(pacoteId),
      selectedProdutos: [],
    });
  };

  limparSelecaoLicenciamento = () => {
    this.setState({
      selectedPacoteId: "",
      selectedProdutos: [],
    });
  };

  validarEmail = (email) => /\S+@\S+\.\S+/.test(email);

  validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i), 10) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9), 10)) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i), 10) * (11 - i);
    }
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10), 10)) return false;

    return true;
  };

  formatPhone = (num) => {
    if (!num) return "";
    if (num.length <= 2) return `(${num}`;
    if (num.length <= 6) return `(${num.slice(0, 2)}) ${num.slice(2)}`;
    if (num.length <= 10) {
      return `(${num.slice(0, 2)}) ${num.slice(2, 6)}-${num.slice(6)}`;
    }
    return `(${num.slice(0, 2)}) ${num.slice(2, 7)}-${num.slice(7)}`;
  };

  formatCPF = (n) => {
    if (!n) return "";
    if (n.length <= 3) return n;
    if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`;
    if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
    return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9)}`;
  };

  formatMoneyBRL = (value) => {
    return Number(value || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
  };

  formatMoneyUSD = (value) => {
    return `US$ ${Number(value || 0).toFixed(2)}`;
  };

  getSelectedPacote = () => {
    const { pacotes, selectedPacoteId } = this.state;
    return pacotes.find((p) => String(p.id) === String(selectedPacoteId)) || null;
  };

  getSelectedProdutosData = () => {
    const { produtos, selectedProdutos } = this.state;
    return produtos.filter((p) => selectedProdutos.includes(p.id));
  };

  getTierInfo = () => {
    const { tier } = this.state;
    const selectedPacote = this.getSelectedPacote();
    const selectedProdutosData = this.getSelectedProdutosData();

    if (selectedPacote && selectedPacote.precos && selectedPacote.precos[tier]) {
      return {
        tipo: "pacote",
        nome: selectedPacote.nome,
        preco: selectedPacote.precos[tier],
        itens: selectedPacote.produtos || [],
      };
    }

    if (selectedProdutosData.length > 0) {
      const total = selectedProdutosData.reduce(
        (acc, produto) => {
          const precoTier = produto.precos?.[tier];
          return {
            valor_brl: acc.valor_brl + Number(precoTier?.valor_brl || 0),
            valor_usd: acc.valor_usd + Number(precoTier?.valor_usd || 0),
            valor_extra_brl:
              acc.valor_extra_brl + Number(precoTier?.valor_extra_brl || 0),
            valor_extra_usd:
              acc.valor_extra_usd + Number(precoTier?.valor_extra_usd || 0),
            slots_inclusos: Number(precoTier?.slots_inclusos || 0),
          };
        },
        {
          valor_brl: 0,
          valor_usd: 0,
          valor_extra_brl: 0,
          valor_extra_usd: 0,
          slots_inclusos: 0,
        }
      );

      return {
        tipo: "produtos",
        nome: "Robôs selecionados",
        preco: total,
        itens: selectedProdutosData,
      };
    }

    return null;
  };

  getCardStyle = (selected) => ({
    cursor: "pointer",
    border: selected ? "3px solid #42a89c" : "2px solid #d9d3ea",
    borderRadius: "14px",
    background: selected ? "linear-gradient(180deg, #ecfffb 0%, #dff7f3 100%)" : "#ffffff",
    boxShadow: selected
      ? "0 0 0 3px rgba(66,168,156,0.18), 0 12px 28px rgba(66,168,156,0.18)"
      : "0 6px 16px rgba(0,0,0,0.08)",
    transform: selected ? "translateY(-2px)" : "none",
    transition: "all 0.18s ease",
    overflow: "hidden",
    minHeight: "100%",
    position: "relative",
  });

  getHeadingStyle = (selected) => ({
    background: selected ? "#42a89c" : "#443c56",
    color: "#fff",
    padding: "18px 14px",
    position: "relative",
  });

  getCheckBadge = (selected) =>
    selected ? (
      <div
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "#ffffff",
          color: "#42a89c",
          border: "2px solid #42a89c",
          borderRadius: "999px",
          width: 34,
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 900,
          fontSize: 18,
        }}
      >
        ✓
      </div>
    ) : null;

  handleCadastro = async () => {
    const {
      nome,
      passwd,
      email,
      phone,
      cpf,
      termosAceitos,
      regiao,
      selectedProdutos,
      selectedPacoteId,
      tier,
    } = this.state;

    const cleanPhone = regiao === "BR" ? phone.replace(/\D/g, "") : phone.trim();

    if (!termosAceitos) {
      this.setState({
        error: true,
        message: "Você deve aceitar os Termos de Uso para continuar.",
      });
      return;
    }

    if (!nome || !passwd || !email || !phone || !cpf) {
      this.setState({
        message: "Preencha todos os campos.",
        error: true,
      });
      return;
    }

    if (passwd.length < 6) {
      this.setState({
        message: "A senha deve ter ao menos 6 caracteres.",
        error: true,
      });
      return;
    }

    if (!this.validarEmail(email)) {
      this.setState({
        message: "Email inválido.",
        error: true,
      });
      return;
    }

    if (!selectedPacoteId && selectedProdutos.length === 0) {
      this.setState({
        message: "Selecione pelo menos um robô ou o pacote completo.",
        error: true,
      });
      return;
    }

    let cpfParaEnvio = cpf.trim();

    if (regiao === "BR") {
      const cleanCPF = cpf.replace(/\D/g, "");
      if (!this.validarCPF(cleanCPF)) {
        this.setState({
          message: "CPF inválido. Verifique o número digitado.",
          error: true,
        });
        return;
      }
      cpfParaEnvio = cleanCPF;
    } else {
      if (!cpfParaEnvio) {
        this.setState({
          message: "Informe um documento/ID válido.",
          error: true,
        });
        return;
      }
    }

    const data = {
      nome,
      passwd,
      email,
      phone: cleanPhone,
      cpf: cpfParaEnvio,
      tier,
    };

    if (selectedPacoteId) {
      data.pacote_id = parseInt(selectedPacoteId, 10);
    } else {
      data.produtos = selectedProdutos;
    }

    this.setState({ loading: true, message: "" });

    try {
      const response = await fetch("https://quantumtrades.com.br:8080/cadastro", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const res = await response.json();

      if (response.ok) {
        this.setState({
          error: false,
          message:
            "Cadastro realizado com sucesso! Sua conta será criada desativada. Entre em contato com nossa equipe para habilitar o acesso e liberar suas licenças.",
          loading: false,
        });

        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        this.setState({
          error: true,
          message: res.message || "Erro ao realizar o cadastro.",
          loading: false,
        });
      }
    } catch (e) {
      this.setState({
        error: true,
        message: "Erro ao conectar ao servidor.",
        loading: false,
      });
    }
  };

  renderTierCards() {
    const { tier } = this.state;

    const tiers = [
      {
        id: "starter",
        nome: "Starter",
        contas: "2 contas MT5 incluídas",
        valor: "R$ 20,00 / mês por robô",
        extra: "Conta extra: R$ 10,00 / mês",
      },
      {
        id: "trader",
        nome: "Trader",
        contas: "5 contas MT5 incluídas",
        valor: "R$ 40,00 / mês por robô",
        extra: "Conta extra: R$ 9,00 / mês",
      },
      {
        id: "pro",
        nome: "Pro",
        contas: "10 contas MT5 incluídas",
        valor: "R$ 70,00 / mês por robô",
        extra: "Conta extra: R$ 8,00 / mês",
      },
    ];

    return (
      <div style={{ marginTop: 35 }}>
        <h3 style={{ color: "#42a89c", textAlign: "center" }}>Passo 2 — Contas MT5</h3>
        <p style={{ textAlign: "center", color: "#2e3757", marginBottom: 20 }}>
          Escolha o tier que será contratado.
        </p>

        <div className="row">
          {tiers.map((item) => {
            const selected = tier === item.id;

            return (
              <div className="col-sm-4" key={item.id} style={{ marginBottom: 20 }}>
                <div style={this.getCardStyle(selected)} onClick={() => this.setState({ tier: item.id })}>
                  <div style={this.getHeadingStyle(selected)}>
                    {this.getCheckBadge(selected)}
                    <h3 style={{ margin: 0, color: "#fff", fontWeight: 700 }}>{item.nome}</h3>
                    <div style={{ marginTop: 8, fontSize: 13, fontWeight: 700, opacity: 0.95 }}>
                      {selected ? "SELECIONADO" : "Clique para selecionar"}
                    </div>
                  </div>

                  <div style={{ padding: 18, textAlign: "center", color: "#2e3757" }}>
                    <p><strong>{item.contas}</strong></p>
                    <p style={{ fontWeight: 700, color: "#42a89c", fontSize: 18 }}>{item.valor}</p>
                    <p>{item.extra}</p>

                    <button
                      type="button"
                      className="cadastro-button"
                      style={{
                        marginTop: 10,
                        width: "100%",
                        backgroundColor: selected ? "#2f7f75" : "#7075b7",
                      }}
                    >
                      {selected ? "Tier selecionado" : "Selecionar tier"}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderProdutos() {
    const { produtos, selectedProdutos } = this.state;

    return (
      <div style={{ marginTop: 35 }}>
        <h3 style={{ color: "#42a89c", textAlign: "center" }}>Passo 1 — Seus robôs</h3>
        <p style={{ textAlign: "center", color: "#2e3757", marginBottom: 20 }}>
          Clique nos robôs que deseja contratar.
        </p>

        <div className="row">
          {produtos.map((produto) => {
            const ativo = selectedProdutos.includes(produto.id);

            return (
              <div className="col-sm-4" key={produto.id} style={{ marginBottom: 20 }}>
                <div style={this.getCardStyle(ativo)} onClick={() => this.toggleProduto(produto.id)}>
                  <div style={this.getHeadingStyle(ativo)}>
                    {this.getCheckBadge(ativo)}
                    <h3 style={{ margin: 0, color: "#fff", fontWeight: 800 }}>
                      {produto.codigo?.toUpperCase()}
                    </h3>
                    <div style={{ marginTop: 8, fontSize: 13, fontWeight: 700, opacity: 0.95 }}>
                      {ativo ? "SELECIONADO" : "Clique para selecionar"}
                    </div>
                  </div>

                  <div style={{ padding: 18, textAlign: "center", color: "#2e3757" }}>
                    <h4 style={{ color: "#443c56", minHeight: 52, fontWeight: 700 }}>
                      {produto.nome}
                    </h4>
                    <p style={{ minHeight: 90 }}>{produto.descricao}</p>

                    <p style={{ fontWeight: 700, color: "#42a89c", marginBottom: 12 }}>
                      A partir de R$ 20,00 / mês
                    </p>

                    <button
                      type="button"
                      className="cadastro-button"
                      style={{
                        marginTop: 10,
                        width: "100%",
                        backgroundColor: ativo ? "#2f7f75" : "#7075b7",
                      }}
                    >
                      {ativo ? "Remover da seleção" : "Selecionar robô"}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderPacotes() {
    const { pacotes, selectedPacoteId } = this.state;

    if (!pacotes.length) return null;

    return (
      <div style={{ marginTop: 20 }}>
        <h3 style={{ color: "#42a89c", textAlign: "center" }}>Ou leve o pacote completo</h3>

        <div className="row">
          {pacotes.map((pacote) => {
            const ativo = String(selectedPacoteId) === String(pacote.id);

            return (
              <div className="col-sm-12" key={pacote.id} style={{ marginBottom: 20 }}>
                <div style={this.getCardStyle(ativo)} onClick={() => this.selectPacote(pacote.id)}>
                  <div style={this.getHeadingStyle(ativo)}>
                    {this.getCheckBadge(ativo)}
                    <h3 style={{ margin: 0, color: "#fff", fontWeight: 800 }}>{pacote.nome}</h3>
                    <div style={{ marginTop: 8, fontSize: 13, fontWeight: 700, opacity: 0.95 }}>
                      {ativo ? "PACOTE SELECIONADO" : "Clique para selecionar o pacote"}
                    </div>
                  </div>

                  <div style={{ padding: 22, textAlign: "center", color: "#2e3757" }}>
                    <p style={{ fontSize: 16 }}>
                      <strong>{pacote.descricao}</strong>
                    </p>

                    {Array.isArray(pacote.produtos) && pacote.produtos.length > 0 && (
                      <p style={{ fontSize: 16 }}>
                        Inclui: <strong>{pacote.produtos.map((p) => p.nome).join(" + ")}</strong>
                      </p>
                    )}

                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                      <span
                        style={{
                          display: "inline-block",
                          background: "#fff3cd",
                          color: "#856404",
                          padding: "8px 14px",
                          borderRadius: 999,
                          fontWeight: 700,
                          border: "1px solid #ffe69c",
                        }}
                      >
                        Economize com o combo
                      </span>
                    </div>

                    <p style={{ marginBottom: 6, color: "#666" }}>
                      De {this.formatMoneyBRL(60)} / mês por
                    </p>
                    <p style={{ fontSize: 28, fontWeight: 800, color: "#42a89c", marginBottom: 10 }}>
                      {this.formatMoneyBRL(pacote.precos?.starter?.valor_brl)} / mês
                    </p>

                    <button
                      type="button"
                      className="cadastro-button"
                      style={{
                        marginTop: 10,
                        width: "100%",
                        backgroundColor: ativo ? "#2f7f75" : "#7075b7",
                      }}
                    >
                      {ativo ? "Pacote selecionado" : "Selecionar pacote"}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ textAlign: "center", marginTop: 8 }}>
          <button
            type="button"
            className="cadastro-button"
            onClick={this.limparSelecaoLicenciamento}
            style={{ backgroundColor: "#8c7aa8" }}
          >
            Limpar seleção
          </button>
        </div>
      </div>
    );
  }

  renderResumo() {
    const resumo = this.getTierInfo();
    const { tier, regiao, selectedProdutos, selectedPacoteId } = this.state;

    const tierNome =
      tier === "starter" ? "Starter" : tier === "trader" ? "Trader" : "Pro";

    const temSelecao = selectedPacoteId || selectedProdutos.length > 0;

    return (
      <div
        style={{
          marginTop: 30,
          background: temSelecao ? "#f6fffc" : "#f5f2fb",
          border: temSelecao ? "2px solid #42a89c" : "2px dashed #c5bdd8",
          borderRadius: 14,
          padding: 22,
          color: "#2e3757",
        }}
      >
        <h3 style={{ color: "#42a89c", marginTop: 0 }}>Resumo da sua assinatura</h3>

        {!resumo ? (
          <p style={{ marginBottom: 0, fontWeight: 700 }}>
            Nenhum robô ou pacote selecionado ainda.
          </p>
        ) : (
          <>
            <p><strong>Plano:</strong> {resumo.nome}</p>
            <p><strong>Tier:</strong> {tierNome}</p>
            <p><strong>Contas incluídas:</strong> {resumo.preco?.slots_inclusos || 0}</p>

            {resumo.tipo === "produtos" && resumo.itens?.length > 0 && (
              <p>
                <strong>Robôs contratados:</strong>{" "}
                {resumo.itens.map((item) => item.nome).join(", ")}
              </p>
            )}

            {resumo.tipo === "pacote" && resumo.itens?.length > 0 && (
              <p>
                <strong>Inclui:</strong> {resumo.itens.map((item) => item.nome).join(", ")}
              </p>
            )}

            {regiao === "BR" ? (
              <>
                <p style={{ fontSize: 22, fontWeight: 800, color: "#42a89c", marginTop: 14 }}>
                  Total mensal: {this.formatMoneyBRL(resumo.preco?.valor_brl)}
                </p>
                <p>
                  <strong>Conta extra:</strong>{" "}
                  {this.formatMoneyBRL(resumo.preco?.valor_extra_brl)} / mês por conta
                </p>
              </>
            ) : (
              <>
                <p style={{ fontSize: 22, fontWeight: 800, color: "#42a89c", marginTop: 14 }}>
                  Total mensal: {this.formatMoneyUSD(resumo.preco?.valor_usd)} / mês
                </p>
                <p>
                  <strong>Conta extra:</strong>{" "}
                  {this.formatMoneyUSD(resumo.preco?.valor_extra_usd)} / mês por conta
                </p>
              </>
            )}
          </>
        )}
      </div>
    );
  }

  render() {
    const {
      nome,
      passwd,
      email,
      phone,
      cpf,
      message,
      error,
      loading,
      termosAceitos,
      showTermos,
      regiao,
      loadingCatalogo,
    } = this.state;

    const isBrasil = regiao === "BR";

    return (
      <div className="cadastro-page">
        <div className="cadastro-container" style={{ maxWidth: "1050px" }}>
          <center>
            <img
              src={require("../img/Quantum7.png")}
              width={150}
              height={200}
              alt="Quantum Trades"
            />
          </center>

          <h2 className="cadastro-titulo">Cadastro Quantum Trades</h2>

          <div
            style={{
              background: "#f6f3fb",
              borderRadius: 14,
              padding: 18,
              margin: "20px auto",
              color: "#2e3757",
              border: "1px solid #ddd6ef",
            }}
          >
            <p>
              <strong><h3>Importante!!!</h3></strong> Sua conta é criada inicialmente{" "}
              <strong>desativada</strong>. Após o cadastro, entre em contato com
              nossa equipe para habilitar o acesso ao robô e liberar suas licenças.
            </p>
            <p style={{ marginTop: 6 }}>
              Nosso objetivo é <strong>ajudar o trader a construir patrimônio</strong>,
              com tecnologia acessível e sem mensalidades abusivas.
            </p>
          </div>

          <div className="input-container" style={{ textAlign: "center" }}>
            <select
              className="cadastro-input"
              name="regiao"
              value={regiao}
              onChange={this.handleInputChange}
            >
              <option value="BR">Brasil</option>
              <option value="AM_SUL">América do Sul (exceto Brasil)</option>
              <option value="AM_NORTE">América do Norte</option>
              <option value="EUROPA">Europa</option>
              <option value="ASIA">Ásia</option>
              <option value="OUTROS">Outras regiões</option>
            </select>

            <input
              className="cadastro-input"
              type="text"
              name="nome"
              value={nome}
              onChange={this.handleInputChange}
              placeholder="Nome completo"
            />

            <input
              className="cadastro-input"
              type="password"
              name="passwd"
              value={passwd}
              onChange={this.handleInputChange}
              placeholder="Senha"
            />

            <input
              className="cadastro-input"
              type="email"
              name="email"
              value={email}
              onChange={this.handleInputChange}
              placeholder="Email"
            />

            <input
              className="cadastro-input"
              type="text"
              name="phone"
              value={phone}
              onChange={this.handleInputChange}
              placeholder={
                isBrasil ? "Telefone (com DDD)" : "Telefone (com código do país)"
              }
            />

            <input
              className="cadastro-input"
              type="text"
              name="cpf"
              value={cpf}
              onChange={this.handleInputChange}
              placeholder={
                isBrasil ? "CPF" : "Documento/ID (passaporte, ID nacional, etc.)"
              }
            />
          </div>

          {loadingCatalogo ? (
            <p style={{ textAlign: "center", marginTop: 20 }}>
              Carregando catálogo de licenciamento...
            </p>
          ) : (
            <>
              {this.renderProdutos()}
              {this.renderPacotes()}
              {this.renderTierCards()}
              {this.renderResumo()}
            </>
          )}

          <div className="cadastro-termos-centralizado" style={{ marginTop: 20 }}>
            <input
              type="checkbox"
              checked={termosAceitos}
              onChange={this.handleInputChange}
              name="termosAceitos"
            />
            <label>
              Eu aceito os&nbsp;
              <button
                type="button"
                className="termos-link-btn"
                onClick={() => this.setState({ showTermos: true })}
              >
                Termos de Uso
              </button>
            </label>
          </div>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <button
              className="cadastro-button"
              onClick={this.handleCadastro}
              disabled={loading || loadingCatalogo}
              style={{
                minWidth: 260,
                fontSize: 16,
                fontWeight: 700,
              }}
            >
              {loading ? "Enviando..." : "Cadastrar"}
            </button>
          </div>

          {message && (
            <p className={`cadastro-message ${error ? "error" : "success"}`}>
              {message}
            </p>
          )}

          <a href="/" className="cadastro-link">
            Voltar
          </a>

          {showTermos && (
            <div
              className="termos-modal-overlay"
              onClick={() => this.setState({ showTermos: false })}
            >
              <div className="termos-modal" onClick={(e) => e.stopPropagation()}>
                <h3>Termos de Uso</h3>
                <div className="termos-text">{TERMO_COMPLETO}</div>

                <button
                  className="footer-terms-btn"
                  onClick={() => this.setState({ showTermos: false })}
                >
                  Fechar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const TERMO_COMPLETO = (
  <div>
    <p>
      O usuário (“USUÁRIO”), ao instalar, ativar, utilizar ou realizar qualquer
      operação com o Quantum Trades EA dentro da plataforma MetaTrader 5 (MT5),
      declara estar ciente e de acordo com os seguintes termos:
    </p>

    <p>
      <strong>1 –</strong> O USUÁRIO instala e utiliza o EA por livre vontade,
      autorizando o tratamento dos dados necessários ao funcionamento,
      estatísticas, segurança e melhoria contínua.
    </p>

    <p>
      <strong>2 –</strong> O USUÁRIO compreende plenamente o funcionamento do
      robô e os riscos financeiros envolvidos em operações automatizadas.
    </p>

    <p>
      <strong>3 –</strong> Toda configuração de risco, volume, reentradas,
      metas, stops, correlação entre ativos e demais parâmetros é de
      responsabilidade exclusiva do USUÁRIO.
    </p>

    <p>
      <strong>4 –</strong> A Quantum Trades não garante lucros, não presta
      consultoria financeira, e não se responsabiliza por perdas provenientes de
      configurações incorretas, slippage, gaps, falhas de conexão, volatilidade
      extrema ou limitações técnicas do MT5.
    </p>

    <p>
      <strong>5 –</strong> O EA opera sobre o MetaTrader 5, desenvolvido pela
      MetaQuotes. Assim, a Quantum Trades não possui responsabilidade por erros
      ou falhas da plataforma.
    </p>

    <p>
      <strong>6 –</strong> O USUÁRIO reconhece que o mercado Forex, índices e
      derivativos envolve risco elevado, podendo resultar em perdas superiores
      ao capital investido.
    </p>

    <p>
      <strong>7 –</strong> Demonstrações, backtests e portfólios não garantem
      resultados futuros.
    </p>

    <p>
      <strong>8 –</strong> É proibida a distribuição, venda ou compartilhamento
      do EA sem autorização da Quantum Trades.
    </p>

    <p>
      <strong>9 –</strong> O EA executa ordens automaticamente seguindo regras
      definidas pelo USUÁRIO, que assume total responsabilidade pelas decisões
      configuradas.
    </p>

    <p>
      <strong>10 –</strong> Eventos extremos, latência, spreads, stop out e gaps
      podem gerar perdas, e essas perdas são de responsabilidade exclusiva do
      USUÁRIO.
    </p>

    <p>
      <strong>11 –</strong> O uso do EA implica aceitação integral destes
      termos.
    </p>

    <p>
      <strong>12 – Direito de arrependimento (7 dias):</strong> o USUÁRIO poderá
      solicitar a devolução integral dos valores pagos pela licença do Quantum
      Trades EA em até <strong>7 (sete) dias corridos</strong> a contar da data
      da primeira contratação/pagamento, caso decida desistir do uso do robô. Após esse
      prazo, não haverá reembolso, ainda que o EA deixe de ser utilizado.
    </p>
  </div>
);